export function formatHorario(horario: any) {
  if (!horario) return "";
  const [hour, minute] = horario;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}
